import { styled } from '@mui/material/styles'

export const ContentDivWrapper = styled('div')({
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
})
